import alocatePrivacyHtml from './alocatePrivacyHtml'
import axios from "axios";

//Call the correct data privacy HTML file from server given the picked jobLayout + language
export default async function callDataPrivHTML(ocaId, language) {
    
              //Hier muss ich einen Call für das DS Dokument machen
              let htmlDocString = alocatePrivacyHtml(ocaId, language);

              // console.log('ocaId is:' + ocaId)
              // console.log('language is:' + language)
              // console.log('html docString is:' + htmlDocString)
              let htmlDocURL = "empty"

              if (process.env.NODE_ENV == "development") {
                
                htmlDocURL = "http://localhost:8080/dataPrivViews/" + htmlDocString
                console.log(htmlDocURL)
              }
              else {
                let scheme = window.location.protocol;
                let host = window.location.hostname;
                let port = window.location.port;
                htmlDocURL = scheme + "//" + host + ":" + port + "/dataPrivViews/" + htmlDocString
              }
            
              let result = await axios
                  .get(htmlDocURL)
                  .then ((privacyResponse) => {
                    // console.log(privacyResponse.data)
                    return privacyResponse.data
                  })
                  .catch((error) => {
                    console.log("error in callDataPrivHTML")
                    return error
                  })

                return { result }
            }